/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GenerateScheduleRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GenerateScheduleResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const generateSchedule = (request: GenerateScheduleRequest, options?: CashRequestOptions) => post<GenerateScheduleRequest, GenerateScheduleResponse>("/2.0/cash/generate-schedule", request, {...options, rejectOnError: true })